import React, { Component } from 'react'
import './App.css'
import Header from './component/common/Header'
import HeaderEmpty from './component/common/HeaderEmpty'
import Footer from './component/common/Footer'
import { Layout } from 'antd'
import VMain from './component/pages/main.js'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {
    console.log(this.props.location.pathname)
  }
  render() {
    const { t } = this.props
    return (
      <div className="App">
        <Layout>
          {this.props.location.pathname === '/scpcontroller' ? '' :(this.props.location.pathname.indexOf('/policy') > -1 || this.props.location.pathname.indexOf('/serviceRights') > -1)?<HeaderEmpty />: <Header />}
          <VMain />
          {this.props.location.pathname === '/scpcontroller' ? '' : <Footer />}
        </Layout>
      </div>
    )
  }
}

export default withRouter(withTranslation()(App))
